import type { Defect } from "@/entities/defect";
import type { Material } from "@/entities/material";

export const getDefectsFromMaterials = (materials: Material[]): Defect[] => {
  return materials.flatMap(({ defects = [], name }) =>
    defects.map((defect) => ({
      ...defect,
      name: `(${name}) ${defect.name}`,
    }))
  );
};
